module.exports = __webpack_public_path__ + "img/88.10.pH.27f58f87.png";